export const _setStudentProfileLiveCourseData = (state, action) => {
  const { studentId, data } = action.payload;

  if (!state.byStudentId) {
    state.byStudentId = {};
  }

  state.byStudentId[studentId] = {
    ...data,
    loaded: true,
    lastFetched: Date.now(),
  };
};
